import { Provider } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { XVII18nService } from './xvi-translate.service';
import { TranslateWrapperService } from './translate-wrapper.service';
import { NotificationI18nService } from './notification-translate.service';

export * from './xvi-translate.service';

export const I18N_SERVICES: Provider[] = [
  {
    provide: TranslateService,
    useClass: TranslateWrapperService,
  },
  XVII18nService,
  NotificationI18nService,
];
